$(document).ready(() => {
  /*
   Takes a {'test': 'value', 'test1': 'value1'} and converts it to ?test=value&test1=value1 if
   the key is not a category. This is preserve any existing query params.
   */
  function removeFiltersFromUrl(searchString, isMobileView) {
    function isCategory(value) {
      const $category = isMobileView ? $(`select[name=${value}]`) : $(`input#show-desktop-dropdown-${value}`);
      return $category.length > 0;
    }

    let newSearchString = '';

    // Goes through each key, checks if the key is a category and if so appends
    // the key and value as a query param.
    return Object.keys(searchString).reduce((total, key, index) => {
      const startingChar = index === 0 ? '?' : '&';
      if (!isCategory(key)) {
        newSearchString += `${startingChar}${key}=${searchString[key]}`;
      }
      return newSearchString;
    }, '');
  }
  $('.share-link-button').click(function() {
    const buttonId = $(this).attr('id');
    const anchorHashtag = buttonId.replace('button_', '');
    // hide all share link copied text and select the copied text to THIS share link button.
    $('.share-link-copied').css('display', 'none');
    $(this).next().css('display', 'inline');
    const hideLinkCopied = () => {
      $(this).next().css('display', 'none');
    };
    window.setTimeout(hideLinkCopied, 2000);
    const { search, pathname, origin } = window.location;

    // We want to filter out the filter category and their values that are appended to url when
    // users filter the tracker.
    const urlSearchParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const paramString = removeFiltersFromUrl(params, $('.sticky-mobile-menu').is(':visible'));

    const shareLink = `${origin}${pathname}${paramString}#${anchorHashtag}`;
    navigator.clipboard.writeText(shareLink);
  });
  // Logic to send event tracker information to Google Analytics on page load
  const { hash } = window.location;
  // If anchor tag is present in URL, and tracker
  // item with that anchor tag exists, send event to GA
  if (hash && $(`${hash}`).hasClass('tracker-item-container')) {
    // Push Page load with anchor tag event to GA4
    const eventObject = {
      event: 'tracker_item_anchor_tag_load',
      tracker_item_anchor_tag_load: {
        v: 12,
        name: 'Tracker Item Anchor Tag Load',
        url: window.location.href,
      },
    };
    window.pushGTMEvent(eventObject);
  }
});
